import { render, staticRenderFns } from "./noticeEditor.vue?vue&type=template&id=24462bc8&scoped=true&"
import script from "./noticeEditor.vue?vue&type=script&lang=js&"
export * from "./noticeEditor.vue?vue&type=script&lang=js&"
import style0 from "./noticeEditor.vue?vue&type=style&index=0&id=24462bc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24462bc8",
  null
  
)

export default component.exports